module.exports = __webpack_public_path__ + "static/media/medication.012b8877.svg";